/** Types */
import * as partnerAgreementTypes from "./types";
/** Routes */
import { agreementRoute } from "./route";

// TODO: Actions
export const createPartnerAgreement = (form) => {
  return {
    type: partnerAgreementTypes.CREATE_PARTNER_AGREEMENT.WATCHER,
    payload: { form },
  };
};

// Send message to partner
export const sentMessageToPartner = (id) => {
  return {
    type: partnerAgreementTypes.SEND_MESSAGE_TO_PARTNER.WATCHER,
    payload: id,
  };
};

// Send message to internal ceo
export const sentMessageToInternalCEO = (id) => {
  return {
    type: partnerAgreementTypes.SEND_MESSAGE_TO_INTERNAL_CEO.WATCHER,
    payload: id,
  };
};

export const setPartnerAgreement = (values) => {
  return {
    type: partnerAgreementTypes.SET_PARTNER_AGREEMENT.WATCHER,
    payload: values,
  };
};

export const setCommitment = (values) => {
  return {
    type: partnerAgreementTypes.SET_COMMITMENT.SUCCESS,
    payload: values,
  };
};

export const downloadPDF = (id) => {
  return {
    type: partnerAgreementTypes.DOWNLOAD_AGREEMENT.WATCHER,
    payload: id,
  };
};

// TODO: Routes
export const successForm = () => {
  return {
    type: partnerAgreementTypes.SUCCESS_FORM.WATCHER,
    payload: agreementRoute.success_form,
  };
};



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/action.js